var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"width":"100%"}},[_c('router-link',{attrs:{"to":"/settings/general/operating_regions"}},[_vm._v("Operating Regions")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }